import { startCase } from 'lodash';
import React from 'react';

import { FrequentPassageRequest } from '@legacy-types';

import { Tooltip } from '@shared/ui/components/Tooltip';

type FrequentPassageRequestStatusBadgeProps = {
  frequentPassageRequest: FrequentPassageRequest;
};

export function FrequentPassageRequestStatusBadge({ frequentPassageRequest }: FrequentPassageRequestStatusBadgeProps) {
  const statusColors = {
    pending: 'metal',
    rejected: 'warning',
    approved: 'success',
    redeemed: 'info',
  };

  return (
    <Tooltip
      content={
        <>
          {frequentPassageRequest.internalNote && (
            <p>
              <strong className="font-bold">Pick-up note:</strong> {frequentPassageRequest.internalNote}
            </p>
          )}
          {frequentPassageRequest.remark && (
            <p>
              <strong className="font-bold">Remark:</strong> {frequentPassageRequest.remark}
            </p>
          )}
        </>
      }
    >
      <span
        className={`m-badge m-badge--${statusColors[frequentPassageRequest.status]} text-sm font-medium px-3 py-1 rounded-full`}
      >
        {startCase(frequentPassageRequest.status)}
        {frequentPassageRequest.remark || frequentPassageRequest.internalNote ? '*' : ''}
      </span>
    </Tooltip>
  );
}
